/**
 * The list's URL-borne search (`?q=`, `?status=`), read eagerly by the route table.
 * Route-table code, not a screen: it sits beside index.ts, outside routes/, because
 * everything under routes/ must load on demand (BND-01, SF-BUNDLE; as dispatch's search.ts).
 */

import type { FleetFilter } from "./api/client";

export interface FleetListSearch {
  q?: string;
  status?: FleetFilter;
}

const FILTERS: readonly FleetFilter[] = ["in_service", "out_of_service", "due_soon", "all", "archived"];

export function validateFleetListSearch(raw: Record<string, unknown>): FleetListSearch {
  const out: FleetListSearch = {};
  if (typeof raw["q"] === "string" && raw["q"]) out.q = raw["q"];
  else if (typeof raw["q"] === "number") out.q = String(raw["q"]);
  const s = raw["status"];
  if (typeof s === "string" && s !== "all" && (FILTERS as readonly string[]).includes(s)) out.status = s as FleetFilter;
  return out;
}
